import { render, staticRenderFns } from "./PurchaseOrderTransferDetail.template.vue?vue&type=template&id=7c6b5b4e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports